<template>
  <div id="app" :class="`${$route.params.lang || 'en'}-page`">
    <router-view></router-view>
  </div>
</template>

<script lang="ts">
export default {
  name: "App",
  components: {},
};
</script>

<style></style>
